import React from "react";
import Icon from "../ui/Icon";

// ไอคอนเส้นเสริมสำหรับหน้าแชท/คอยน์ (สไตล์เดียวกับ ui/Icon.js)
const PATHS = {
  refresh: "M20 11a8 8 0 0 0-14.9-3M4 4v4h4M4 13a8 8 0 0 0 14.9 3M20 20v-4h-4",
  copy: "M9 9h11v11H9zM5 15V4h11",
  thumb: "M7 11v9H3v-9zM7 11l4-8a2 2 0 0 1 2 2v4h6a2 2 0 0 1 2 2l-1.5 7a2 2 0 0 1-2 1.5H7",
  pencil: "M4 20h4L19 9l-4-4L4 16zM13.5 6.5l4 4",
  phone: "M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2",
  mic: "M12 14a3 3 0 0 0 3-3V6a3 3 0 0 0-6 0v5a3 3 0 0 0 3 3zM5 11a7 7 0 0 0 14 0M12 18v3",
  image: "M4 5h16v14H4zM4 16l5-5 4 4 3-3 4 4M9 9h.01",
  flame: "M12 3c1 4 5 5 5 10a5 5 0 0 1-10 0c0-2 1-3 2-4 0 2 1 3 2 3 0-3-1-5 1-9z",
  pin: "M12 17v5M8 3h8l-1 6 3 4H6l3-4z",
  archive: "M3 5h18v4H3zM5 9v10h14V9M10 13h4",
  trash: "M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13",
  lock: "M6 11h12v9H6zM8 11V8a4 4 0 0 1 8 0v3",
  cards: "M7 3h8v14H7zM10 7h2M17 7l3 1-3 12-6-1.5",
  diamond: "M6 4h12l4 6-10 11L2 10zM2 10h20M8 4l4 17M16 4l-4 17",
  info: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 11v6M12 7.5h.01",
  chevron: "M9 6l6 6-6 6",
  share: "M18 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM18 22a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM8.6 13.5l6.8 4M15.4 6.5l-6.8 4",
  card: "M3 6h18v12H3zM3 10h18M7 15h4",
  qr: "M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h2v2h-2zM18 14h2v6h-4M14 18h2",
  edit: "M4 20h4L19 9l-4-4L4 16z",
};

export default function ChatIcon({ name, size = 18, strokeWidth = 1.9, className, filled }) {
  // ชื่อที่ไม่อยู่ในชุดนี้ -> ใช้ไอคอนของ design system (ui/Icon)
  if (!PATHS[name]) return <Icon name={name} size={size} strokeWidth={strokeWidth} className={className} filled={filled} />;
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill={filled ? "currentColor" : "none"} stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d={PATHS[name]} />
    </svg>
  );
}
